'use strict';
var parent = require('../../stable/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/object/assign.js
// module id = 331
// module chunks = 0